import React, { useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import StarGroup from './StarGroup';
import { scaleW } from '@/common/style';
import { IComment, IVideoCoverType } from './types';
import { vIf } from '@/common/utils/vIf';
import IconArrow from '@/assets/icon/icon_arrow_black_16.png';
import IconArrowDown from '@/assets/icon/icon_arrow_grey_16.png';
import { Box, Flex, KFlex, Space } from '@kibt/meta-ui-krn';
import { $k18n } from '@/common/i18n';
import Image from '@kds/image';
import { userId } from '@/common/const';
import { KTouchableOpacity } from '@/component/RtlLayout/Touchable';
import VideoOrImageCover from './VideoOrImageCover';
import LikeIcon from './LikeIcon';
import { isSmallDeviceWidth } from '@/common/device-info';

const imgSize = isSmallDeviceWidth ? scaleW(88) : scaleW(108);
const style = StyleSheet.create({
    container: {
        // ...padding(scaleW(16), scaleW(19)),
    },
    info: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    avatar: {
        width: scaleW(28),
        height: scaleW(28),
        borderRadius: scaleW(14),
    },
    username: {
        marginHorizontal: scaleW(8),
        color: 'rgba(0, 0, 0, 0.88)',
        maxWidth: scaleW(130),
    },
    specDesc: {
        // marginTop: scaleW(12),
        color: '#C2C2C2',
        fontSize: scaleW(12),
    },
    commentWrapper: {
        flexDirection: 'row',
        alignItems: 'flex-end',
    },
    comment: {
        marginTop: scaleW(8),
        color: 'rgba(0, 0, 0, 0.88)',
        fontSize: scaleW(14),
        flexShrink: 1,
    },
    transparentComment: {
        color: 'rgba(0, 0, 0, 0)',
    },
    date: {
        color: 'rgba(0, 0, 0, 0.4)',
        fontSize: 12,
        lineHeight: 14,
        marginTop: scaleW(12),
    },
    images: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginTop: scaleW(12),
    },
    image: {
        width: '100%',
        height: '100%',
        // borderColor: 'rgba(0, 0, 0, 0.05)',
        // borderStyle: 'solid',
        // borderWidth: 1,
    },
    imageContainer: {
        position: 'relative',
        width: imgSize,
        height: imgSize,
        borderRadius: scaleW(8),
        overflow: 'hidden',
        marginBottom: scaleW(8),
    },
    imageBorder: {
        position: 'absolute',
        width: imgSize,
        height: imgSize,
        borderRadius: scaleW(8),
        // backgroundColor: 'red',
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: 'rgba(0, 0, 0, 0.05)',
    },
    imageMarginLeft: {
        marginLeft: scaleW(8),
    },
    arrowUp: {
        transform: [{ rotate: '180deg' }],
    },
    arrow: {
        width: 16,
        height: 16,
        marginLeft: 3,
    },
});

interface ICommentCardProps {
    max?: number;
    showTime?: boolean;
    showLikeIcon?: boolean;
    liked?: boolean;
    likeCount?: number;
    onClickImage?: (params: { image: string; index: number; videoAndImgs: IVideoCoverType[] }) => void;
}

const MAX_TEXT_LINES = 3;
const CommentCard = (props: IComment & ICommentCardProps) => {
    const { showTime = true, showLikeIcon = false, liked = false, likeCount = 0, commentId } = props;

    const [titleInfo, setTitleInfo] = useState({
        numLines: null,
        maxHeight: 0,
        showOpenDetail: false,
        isFlat: false,
    });

    const [foldMerchantRely, setFoldMerchantRely] = useState(true);

    const formatTime = () => {
        const date = new Date(props.createTime);
        const M = date.getMonth() + 1;
        const Y = date.getFullYear();
        const D = date.getDate();
        const f = v => (v > 9 ? v : `0${v}`);
        // 'DD/MM/YYYY';
        return `${f(D)}/${f(M)}/${f(Y)}`;
    };

    const onDetailLayout = event => {
        const height = Math.floor(event.nativeEvent.layout.height || 0);
        // 第一次测量view的最大高度
        if (titleInfo.maxHeight === 0) {
            setTitleInfo({
                ...titleInfo,
                maxHeight: height,
                numLines: MAX_TEXT_LINES,
            });
            // 第二次当测量的最大高度>设置行数后的高度的时候，则需要展开按钮。
        } else if (titleInfo.maxHeight > height) {
            if (!titleInfo.showOpenDetail) {
                setTitleInfo({
                    ...titleInfo,
                    showOpenDetail: true,
                    isFlat: false,
                });
            }
        }
    };

    const onChangeTextCollapse = () => {
        if (titleInfo.isFlat) {
            setTitleInfo({
                ...titleInfo,
                isFlat: false,
                numLines: MAX_TEXT_LINES,
            });
        } else {
            setTitleInfo({
                ...titleInfo,
                numLines: null,
                isFlat: true,
            });
        }
    };

    const originVideoAndImgs = (() => {
        const { videoList = [], imageUrl = [] } = props;
        const _videos = videoList?.map(i => ({
            isVideo: true,
            poster: i.videoCoverUrl,
            url: i.videoMainUrl,
        }));
        const _imgs = imageUrl?.map(i => ({
            isVideo: false,
            poster: '',
            url: i,
        }));
        return [..._videos, ..._imgs];
    })();

    const videoAndImgs = (() => {
        const { videoList = [], imageUrl = [] } = props;
        const _videos = videoList?.map(i => ({
            isVideo: true,
            poster: i.videoCoverUrl,
            url: i.videoMainUrl,
        }));
        const _imgs = imageUrl?.map(i => ({
            isVideo: false,
            poster: '',
            url: i,
        }));
        if (props.max && Number(props.max)) {
            return [..._videos, ..._imgs].slice(0, props.max);
        }
        return [..._videos, ..._imgs];
    })();

    // console.log(videoAndImgs, 'videoAndImgs::::');

    return (
        <View style={style.container}>
            <View style={style.info}>
                <View
                    style={{"flexDirection":"row","justifyContent":"flex-start","alignItems":"flex-start"}}>
                    <Image style={style.avatar} source={{ uri: props.userHeadUrl }} />
                    <Text numberOfLines={1} ellipsizeMode={'tail'} style={style.username}>
                        {props.userName}
                    </Text>
                    {Number(userId) === Number(props.userId) && (
                        <View
                            style={{"height":"4.347826086956522rem","backgroundColor":"rgba(0, 0, 0, 0.05)","borderRadius":"0.7246376811594204rem","paddingHorizontal":"0.9661835748792271rem","justifyContent":"center"}}>
                            <Text
                                style={{"lineHeight":"4.1062801932367154rem","color":"rgba(0, 0, 0, 0.4)","fontSize":"2.6570048309178746rem"}}>
                                {$k18n({ id: 'k_442587', text: '我的评价' })}
                            </Text>
                        </View>
                    )}
                </View>
                <StarGroup yellowStarCount={props.productScore} startStyle={{ width: 12, height: 12 }} />
            </View>
            <View style={{"marginLeft":"8.695652173913045rem"}}>
                <Text style={style.specDesc}>{props.skuSpecDesc}</Text>
                {vIf(
                    Boolean(props.detail),
                    <View style={style.commentWrapper}>
                        <Text
                            numberOfLines={titleInfo.numLines}
                            style={[style.comment, titleInfo.maxHeight === 0 ? style.transparentComment : {}]}
                            onLayout={onDetailLayout}>
                            {props.detail}
                        </Text>
                        {titleInfo.showOpenDetail ? (
                            <KTouchableOpacity activeOpacity={0.6} hitSlop={{ top: 100, left: 100 }} onPress={onChangeTextCollapse}>
                                <Image style={[style.arrow, titleInfo.isFlat ? style.arrowUp : {}]} source={IconArrow} />
                            </KTouchableOpacity>
                        ) : null}
                    </View>
                )}
                {vIf(
                    videoAndImgs?.length > 0,
                    <View style={style.images}>
                        {videoAndImgs?.map((item, index) => (
                            <KTouchableOpacity
                                activeOpacity={0.6}
                                onPress={() => props.onClickImage({ image: item.url, index, videoAndImgs: originVideoAndImgs })}>
                                <View style={[style.imageContainer, index % 3 !== 0 ? style.imageMarginLeft : {}]}>
                                    <VideoOrImageCover iconSize={30} url={item.url} poster={item.poster} isVideo={item.isVideo} />
                                    <View style={style.imageBorder} />
                                </View>
                            </KTouchableOpacity>
                        ))}
                    </View>
                )}
                <KFlex style={{"justifyContent":"space-between"}}>
                    {showTime ? <Text style={style.date}>{formatTime()}</Text> : null}
                    {showLikeIcon ? (
                        <LikeIcon liked={liked} likeCount={likeCount} commentId={commentId} videoList={props.videoList} style={{"marginTop":"2.8985507246376816rem"}} />
                    ) : null}
                </KFlex>
            </View>
        </View>
    );
};

export default CommentCard;
